import { render } from "./AdminPagesServicesList.vue?vue&type=template&id=7ba792a9"
import script from "./AdminPagesServicesList.vue?vue&type=script&lang=js"
export * from "./AdminPagesServicesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__